export enum DynamicFormFieldTypes {
  FILE = 'file', // NOTE: in strapi they are using MEDIA type instead with option of [Multiple Media, Single Media]
  TEXT = 'string',
  RELATIONSHIP = 'relationship',
  RADIO = 'radio',
  SELECT = 'select',
  NUMBER = 'integer',
  CHECKBOX = 'checkbox',
  LONG_TEXT = 'longtext',
}

export enum DocumentStatus {
  PUBLISHED = 'published',
  NOT_PUBLISHED = 'not published',
}

export enum FolderManagerItemActionNames {
  EDIT,
  DELETE,
  RESTORE,
  SHARE,
  DOWNLOAD,
  DOWNLOAD_DECK,
  RENAME,
  UPLOAD,
  MANAGE_VERSIONS,
  MOVE,
  EXPORT,
  ADD_TO_PRESENTATION,
  REMOVE_FROM_PRESENTATION,
  MANAGE_THEME,
  COPY,
  CLONE,
}

export enum FolderManagerItemActionTypes {
  SINGLE,
  MULTI,
}
